import { React, useState, useEffect } from "react";
//Redux
import { useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { modifyFilterStatementList } from "../../../page/FilterPage/FilterSlice.js";


import { RangeSlider } from "../../../components/ReactAria/RangeSlider.js";
import { convertRuntime } from "../../../utility/utility.js";

export const RuntimeFilter = (props) => {
  const { genreList, className, focusSection } = props;
  let [runtime, setRuntime] = useState([60, 180]);
  let [filterStatement, setFilterStatement] = useState("");

  //Update Filter List
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      modifyFilterList({
        field: "runtime",
        payload: runtime,
      })
    );
    setFilterStatement(
      runtime[0] < runtime[1]
        ? `from ${convertRuntime(runtime[0])} to ${
            runtime[1] > 180 ? "more than 3h" : convertRuntime(runtime[1])
          }`
        : runtime[1] > 180
        ? `more than ${convertRuntime(runtime[1])}`
        : `less than ${convertRuntime(runtime[0])}`
    );
  }, [runtime]);
  //Update Statement List
  useEffect(() => {
    dispatch(
      modifyFilterStatementList({
        field: "runtime",
        payload: filterStatement,
      })
    );
  }, [filterStatement]);

  useEffect(() => {
    setRuntime([60, 180]);
  }, [genreList]);

  return (
    <div
      className={`${className} ${
        focusSection == className ? "filter_active" : ""
      }`}
    >
      <div className="runtime_filter_content">
        <div className="runtime_range_container">
          <RangeSlider
            label="Runtime"
            minValue={30}
            maxValue={210}
            step={30}
            value={runtime}
            onChange={setRuntime}
            extraThumbContent={[" minutes", "Over 3h"]}
          />
        </div>
      </div>
      <div className="runtime_filter_checked_display">
        <p>
          Your movie would be{" "}
          {filterStatement}
        </p>
      </div>
    </div>
  );
};

